import { z } from "zod/v4-mini";

import { Schema, cz } from "@/utils/zodUtils.ts";

export type SupportInfo = {
  supportEmail: string;
  supportPhoneNumber: string;
};

export const supportInfoSchema: Schema<SupportInfo> = cz.transform(
  cz.camelCaseObject({
    support_mail: z.string(),
    support_phone_number: z.string(),
  }),
  data => ({
    supportEmail: data.supportMail,
    supportPhoneNumber: data.supportPhoneNumber,
  }),
);
